export const PRODUCT_CONSTS = {
    GET_PRODUCTS: "GET_PRODUCTS",
    GET_PRODUCT_BY_ID: "GET_PRODUCT_BY_ID",
    ADD_PRODUCT: "ADD_PRODUCT",
    UPDATE_PRODUCT: "UPDATE_PRODUCT",
    TOGGLE_PRODUCT_VISIBILITY: "TOGGLE_PRODUCT_VISIBILITY",
    DELETE_PRODUCT: "DELETE_PRODUCT",
};
